import React from 'react';
import { Dropdown } from 'antd';
import { MindMapContext } from '../../../../Context/contex';
import { useDownloadImage } from '../../../DownloadImageButton';
import { usePrintMindMap } from '../../../Print';
import { useImportExport } from '../../../ImportExport';
import { useClearMap } from '../../../MapActions/useClearMap';
import ToolButton from './ToolButton';
import { ClearIcon, DownloadIcon, FileTransferIcon, PrintIcon } from './toolIcons';
import styles from './HeaderTools.module.css';

const IMPORT_KEY = 'import';
const EXPORT_MINDMAP_KEY = 'export.mindmap';

const IMPORT_EXPORT_ITEMS = [
    { key: IMPORT_KEY, label: 'Import' },
    { key: 'export', label: 'Export', children: [{ key: EXPORT_MINDMAP_KEY, label: '.mindmap' }] },
];

/**
 * The map tools in the bar: download as image, import / export, print, and (for editors) clear the map.
 * Hidden below 768px (the menu has them).
 */
const HeaderTools = () => {
    const { isReadOnly } = MindMapContext();
    const downloadImage = useDownloadImage();
    const print = usePrintMindMap();
    const clearMap = useClearMap();
    const { startImport, startExport, holder } = useImportExport();

    const actions = { [IMPORT_KEY]: startImport, [EXPORT_MINDMAP_KEY]: startExport };
    const importExportMenu = { items: IMPORT_EXPORT_ITEMS, onClick: ({ key }) => actions[key]?.() };

    return (
        <div className={styles.tools}>
            <ToolButton title="Download image" onClick={downloadImage}>
                <DownloadIcon />
            </ToolButton>
            <Dropdown menu={importExportMenu} trigger={['click']}>
                <ToolButton title="Import / Export">
                    <FileTransferIcon />
                </ToolButton>
            </Dropdown>
            <ToolButton title="Print" onClick={print}>
                <PrintIcon />
            </ToolButton>
            {!isReadOnly && (
                <ToolButton title="Clear mind map" onClick={clearMap}>
                    <ClearIcon />
                </ToolButton>
            )}
            {holder}
        </div>
    );
};

export default HeaderTools;
